/**
 * Generacion de identificadores.
 *
 * Se usan identificadores generados en el dispositivo y no autoincrementales
 * porque asi los registros pueden combinarse mas adelante con otro dispositivo
 * o con una sincronizacion en la nube sin colisiones, sin que eso forme parte
 * del MVP.
 */

/** Identificador unico. Prefijo legible para facilitar la depuracion. */
export function nuevoId(prefijo: string): string {
  return `${prefijo}_${uuid()}`;
}

function uuid(): string {
  const c = globalThis.crypto;

  if (typeof c?.randomUUID === 'function') {
    return c.randomUUID();
  }

  // Respaldo para contextos sin randomUUID. La aplicacion se sirve por HTTPS,
  // asi que en la practica no deberia usarse.
  if (typeof c?.getRandomValues === 'function') {
    const bytes = c.getRandomValues(new Uint8Array(16));
    return Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
  }

  return `${Date.now().toString(36)}${Math.random().toString(36).slice(2, 10)}`;
}
